module.exports = __webpack_public_path__ + "img/index.ad30b9e0.png";